






































import PagedMixin from '@/common/pagination/mixins/paged-mixin'
import Tenant from '@/tenants/entities/tenant'
import { Component, Mixins, Prop, Vue, Watch } from 'vue-property-decorator'

@Component
export default class TenantsTable extends Mixins(PagedMixin) {
  @Prop({ type: Boolean, default: false })
  public loading!: boolean

  @Prop({ default: () => [] })
  public tenants!: Tenant[]

  private get headers() {
    return [
      {
        text: this.$tc('common.company.singular'),
        value: 'company',
        sortable: false,
      },
      {
        text: this.$tc('common.name.full'),
        value: 'name',
        sortable: false,
      },
      {
        text: this.$tc('common.email.singular'),
        value: 'email',
        sortable: false,
      },
      {
        text: this.$tc('common.address.singular'),
        value: 'address',
        sortable: false,
      },
      {
        text: this.$tc('tenants.models.tenant.canCreateGlobalCompetences'),
        value: 'canCreateGlobalCompetences',
        sortable: false,
      },
      {
        text: '',
        value: 'action',
        sortable: false,
        cellClass: 'table-actions',
        align: 'end',
      },
    ]
  }

  private edit(tenant: Tenant) {
    this.$emit('edit', tenant)
  }
}
